export default "/images/adminsignature.png?3e9bc0fe539d87fa6903365f7ac1097a";